
$(document).ready(function() {
  // On hover for desktop, show mega menu
  if (window.matchMedia("(min-width: 993px)").matches) {
  $('.navbar .dropdown').hover(function() {
      $(this).find('.mega-menu').stop(true, true).slideDown(0); // Show mega menu on hover
  }, function() {
      $(this).find('.mega-menu').stop(true, true).slideUp(0); // Hide mega menu when hover out
  });
  }

  if (window.matchMedia("(max-width: 992px)").matches){
   $(".dropdown").click(function(){
    $(this).toggleClass("show").siblings(".dropdown").removeClass("show");
  });
  }

  // On click for mobile, toggle mega menu visibility
  // $('.navbar .dropdown > a').click(function(e) {
  //     var $megaMenu = $(this).next('.mega-menu');
  //     if ($megaMenu.is(':visible')) {
  //         $megaMenu.slideUp(0); // If the mega menu is already visible, hide it
  //     } else {
  //         $('.mega-menu').slideUp(0); // Hide all mega menus
  //         $megaMenu.stop(true, true).slideDown(0); // Show the clicked mega menu
  //     }
  //     e.stopPropagation(); // Prevent click from propagating to parent <li>
  // });

  // Close the mega menu when clicking outside
  $(document).click(function(e) {
      if (!$(e.target).closest('.navbar .dropdown').length) {
          $('.mega-menu').slideUp(0);
      }
  });
});


$(document).ready(function() {
   $('.navbar-toggle').click(function() {
     $(this).toggleClass('open'); // Toggle the hamburger/cross icon
     $('.navbar').toggleClass('open'); // Toggle navbar visibility
     $('body').toggleClass('scroll_invisible');
   });

  // $(".search-icon").click(function(){
  //   $(".head-search, .cross-icon").toggle();
  // });

  // $(".cross-icon").click(function(){
  //   $(".head-search, .cross-icon").hide();
  // });

  //slick Sliders
  $('#hero-banner').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      autoplay: true,
      dots: true,
      infinite: true,
  });

  //Best Seller
  $('#seller-slider').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      arrows: true,
      autoplay: false,
      dots: false,
      responsive: [
          {
              breakpoint: 1299,
              settings: {

                  autoplay: true,
                  slidesToShow: 3
              }
          },
          {
              breakpoint: 991,
              settings: {
                  slidesToShow: 2,
              }
          },
          {
              breakpoint: 767,
              settings: {
                  slidesToShow: 1,
                  arrows: false,
              }
          }
      ]
  });

  function initializeSlick() {
      $('#product-feature').slick({
        dots: false,
        arrows: false,
        autoplay: true,
        autospeed: 1000,
        infinite: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        mobileFirst: true,
        responsive: [
          {
            breakpoint: 991,
            settings: "unslick" // Disable Slick on desktop
          },
          {
              breakpoint: 767,
              settings: {
                  slidesToShow: 3,
                  arrows: false,
              }
          }
        ]
      });
    }
    initializeSlick();
    // Reinitialize Slick if the window is resized to below 768px
    $(window).on('resize', function() {
      if ($(window).width() < 991 && !$('#product-feature').hasClass('slick-initialized')) {
        initializeSlick();
      }
    });

    $('#about-product-slider').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      arrows: true,
      autoplay: false,
      dots: false,
      responsive: [
          {
              breakpoint: 1299,
              settings: {

                  autoplay: true,
                  slidesToShow: 4
              }
          },
          {
              breakpoint: 991,
              settings: {
                  slidesToShow: 3,
              }
          },
          {
              breakpoint: 767,
              settings: {
                  slidesToShow: 2,
                  arrows: false,
              }
          },
          {
              breakpoint: 430,
              settings: {
                  slidesToShow: 1,
                  arrows: false,
              }
          }
      ]
  });

    $('#shop-slider').slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      arrows: true,
      autoplay: false,
      dots: false,
      responsive: [
          {
              breakpoint: 1299,
              settings: {

                  autoplay: true,
                  slidesToShow: 3
              }
          },
          {
              breakpoint: 991,
              settings: {
                  slidesToShow: 2,
              }
          },
          {
              breakpoint: 767,
              settings: {
                  slidesToShow: 1,
                  arrows: false,
              }
          }
      ]
  });

    $('#size_slider').slick({
      slidesToShow: 5,
      slidesToScroll: 1,
      arrows: true,
      autoplay: false,
      dots: false,
      responsive: [
          {
              breakpoint: 1299,
              settings: {

                  autoplay: true,
                  slidesToShow: 4
              }
          },
          {
              breakpoint: 991,
              settings: {
                arrows: true,
                  slidesToShow: 3,
              }
          },
          {
              breakpoint: 767,
              settings: {
                arrows: false,
                  slidesToShow: 3,
                autoplay: true,
              }
          },
          {
              breakpoint: 600,
              settings: {
                arrows: false,
                  slidesToShow: 2,
                autoplay: true,
              }
          }
      ]
  });

  $('#room-slider').slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      arrows: true,
      autoplay: false,
      dots: false,
      responsive: [
          {
              breakpoint: 1299,
              settings: {

                  autoplay: true,
                  slidesToShow: 3
              }
          },
          {
              breakpoint: 991,
              settings: {
                  slidesToShow: 2,
              }
          },
          {
              breakpoint: 767,
              settings: {
                  slidesToShow: 1,
                  arrows: false,
              }
          }
      ]
  });

  $('#recommended-slider').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      arrows: true,
      autoplay: false,
      dots: false,
      responsive: [
          {
              breakpoint: 1299,
              settings: {

                  autoplay: true,
                  slidesToShow: 3
              }
          },
          {
              breakpoint: 991,
              settings: {
                  slidesToShow: 2,
              }
          },
          {
              breakpoint: 767,
              settings: {
                  slidesToShow: 1,
                  arrows: false,
              }
          }
      ]
  });

  function initializeMobileSlick() {
    if ($(window).width() < 768) {
      // Initialize Slick for #testimonial-mobile-slide if not already initialized
      if (!$('#testimonial-mobile-slider').hasClass('slick-initialized')) {
        $('#testimonial-mobile-slider').slick({
          dots: false,
          arrows: false,
          infinite: false,
          slidesToShow: 1,
          slidesToScroll: 1
        });
      }
      
      // Initialize Slick for #testimonial-mobile-slide-2 if not already initialized
      if (!$('#blog_article').hasClass('slick-initialized')) {
        $('#blog_article').slick({
          dots: false,
          arrows: false,
          infinite: false,
          slidesToShow: 1,
          slidesToScroll: 1
        });
      }
      
    } else {
      // Unslick #testimonial-mobile-slide if already initialized on desktop
      if ($('#testimonial-mobile-slide').hasClass('slick-initialized')) {
        $('#testimonial-mobile-slide').slick('unslick');
      }
      
      // Unslick #blog_article if already initialized on desktop
      if ($('#blog_article').hasClass('slick-initialized')) {
        $('#blog_article').slick('unslick');
      }
    }
  }
  
  // Initialize Slick on page load based on screen width
  initializeMobileSlick();
  
  // Re-check Slick initialization on window resize
  $(window).on('resize', function() {
    initializeMobileSlick();
  });
    //slider closed


    // Set initial pagination values
  let totalSlides = $('#hero-banner').slick('getSlick').slideCount;
  $('.total-slides').text(totalSlides.toString().padStart(2, '0'));

  // Update current slide number on slide change
  $('#hero-banner').on('afterChange', function(event, slick, currentSlide){
      $('.current-slide').text((currentSlide + 1).toString().padStart(2, '0'));
  });

  //Accordion footer
 // $('.accordion-header').on('click', function() {
    //  if ($(window).width() < 1280) { // Apply only on mobile view
      //  $(this).toggleClass('active');
      //  $(this).next('.accordion-content').slideToggle(300);
    //  }
   // });
  });

  
  // Ensure content stays open if screen is resized to desktop
  //$(window).on('resize', function() {
    //if ($(window).width() >= 1280) {
      //$('.accordion-content').show();
    //  $('.accordion-header').removeClass('active');
   // } else {
   //   $('.accordion-content').hide();
   // }

//});

//PLP Page start
$(document).ready(function() {
  // Open the Price Filter panel
  $('#price-filter').click(function() {
      $('#price-filter-panel').css('bottom', '52px');
  });

  // Open the Category Filter panel
  $('#category-filter').click(function() {
      $('#category-filter-panel').css('bottom', '52px');
  });

  // Close the Price Filter panel
  $('#close-price-filter').click(function() {
      $('#price-filter-panel').css('bottom', '-100%');
  });

  // Close the Category Filter panel
  $('#close-category-filter').click(function() {
      $('#category-filter-panel').css('bottom', '-100%');
  });

  // Handle filter selection change (for demonstration, you can extend functionality)
  $('#price-select').change(function() {
      var selectedPrice = $(this).val();
      alert('Price filter selected: ' + selectedPrice);
  });

  $('#category-select').change(function() {
      var selectedCategory = $(this).val();
      alert('Category filter selected: ' + selectedCategory);
  });
});

//PDP Page start
$(document).ready(function() {
// Initialize thumbnail slider
$('.thumbnails-slider').slick({
  vertical: true,
  slidesToShow: 5,
  arrows: false,
  infinite: true,
  focusOnSelect: true,
  asNavFor: '.main-image-slider',
  responsive: [
    {
        breakpoint: 1027,
        settings: {
          arrows: true,
          vertical: false,
        }
    },
    {
        breakpoint: 767,
        settings: {
          vertical: false,
          arrows: true,
          slidesToShow: 3,
        }
    },
]
});

// Initialize main image slider
$('.main-image-slider').slick({
  slidesToShow: 1,
  draggable: false,
  arrows: false,
});

// Sync the main image slider with the thumbnail slider
$('.thumbnails-slider').on('click', 'img', function() {
  var index = $(this).index();
  $('.main-image-slider').slick('slickGoTo', index);
});

$('.main-image-slider').on('beforeChange', function(event, slick, currentSlide, nextSlide) {
  $('.thumbnails-slider').slick('slickGoTo', nextSlide);
});

//add subtract quantity
let quantity = 1; // Initial quantity
// Display the current quantity
$('#quantity').text(quantity);

// Add button functionality
$('#add').click(function() {
    quantity++; // Increase quantity by 1
    $('#quantity').text(quantity); // Update the displayed quantity
});

// Subtract button functionality
$('#subtract').click(function() {
    if (quantity > 0) { // Prevent negative quantity
        quantity--; // Decrease quantity by 1
        $('#quantity').text(quantity); // Update the displayed quantity
    }
});
});

$(document).ready(function() {
// Check the window width on document load
function checkWidth() {
  if ($(window).width() <= 767) {
    // Toggle visibility of .head-search and .cross-icon when .search-icon is clicked
    $(".search-icon").click(function() {
      $(".head-search, .cross-icon").toggle();
    });

    // Hide .head-search and .cross-icon when .cross-icon is clicked
    $(".cross-icon").click(function() {
      $(".head-search, .cross-icon").hide();
    });
  }
}

// Run checkWidth on page load
checkWidth();

// Optionally, re-run checkWidth when the window is resized
$(window).resize(function() {
  checkWidth();
});
});


//FAQS
$(document).ready(function() {
  // Toggle FAQ answer and icon (plus or minus) when clicked
  $(".faq-question").click(function() {
    var $answer = $(this).next(".faq-answer");
    var $toggle = $(this).find(".faq-toggle");

    // Check if the current answer is visible
    if ($answer.is(":visible")) {
      // If visible, close it and set the icon to "+"
      $answer.slideUp();
      $toggle.text("+");
      $(this).removeClass('special-faq');
    } else {
      // If not visible, open it and set the icon to "-"
      $answer.slideDown();
      $toggle.text("-");
      $(this).addClass('special-faq');

      // Close all other answers and reset their icons
      $(".faq-answer").not($answer).slideUp();
      $(".faq-toggle").not($toggle).text("+");
      $(".faq-question").not(this).removeClass('special-faq');
    }
  });


// my cart
jQuery(window).ready(function(){
  // Cart 
  $('.add-cart-icon').click(function(){
    $('.my-cart-pop').addClass('show-cart');
    $('.my-cart-pop').removeClass('hide-cart'); 
    $('.overlay').fadeIn(5);
  });
  
  $('.my-cart-pop .details-cross-icon, .overlay').click(function(){
    $('.my-cart-pop').addClass('hide-cart'); 
    $('.my-cart-pop').removeClass('show-cart');
    $('.overlay').fadeOut();
  });

});

});





// Set pointer cursor for quantity change buttons
$('.qty-plus-sub, .qty-minus-sub').css("cursor", "pointer");

// Event listener for the "+" button (increment quantity)
jQuery(document).on('click', '.qty-plus-sub', function(e) {
    e.preventDefault();

    var item = jQuery(this).attr('data-item').replace(':', '\\:');
    var $input = jQuery('.item_' + item + ' .qty'); // Select the quantity input for the item
    var value = parseInt($input.val()); // Get the current value
    var max = parseInt($input.attr('max')); // Get the max quantity from the attribute

    // If the max value is less than 1, show an alert and stop
    if (max < 1) {
        alert('Product not available');
        return false;
    }

    // Check if the new value exceeds the max quantity
    if (value < max) {
        value++; // Increment quantity
        $input.val(value); // Update the quantity input value
        cartChange(item); // Trigger cart update
    } else {
        alert('Maximum ' + max + ' quantity allowed.');
    }
});

// Event listener for the "-" button (decrement quantity)
jQuery(document).on('click', '.qty-minus-sub', function(e) {
    e.preventDefault();

    var item = jQuery(this).attr('data-item').replace(':', '\\:');
    var $input = jQuery('.item_' + item + ' .qty'); // Select the quantity input for the item
    var value = parseInt($input.val()); // Get the current value
    var min = parseInt($input.attr('min')); // Get the minimum quantity from the attribute

    // Prevent decreasing below the minimum value
    if (value > min) {
        value--; // Decrement quantity
        $input.val(value); // Update the quantity input value
        cartChange(item); // Trigger cart update
    }
});

// Function to update the cart after changing the quantity
function cartChange(item) {
    var qty = jQuery('.item_' + item + ' .qty').val(); // Get the updated quantity

    var formData = { updates: {} };
    formData.updates[item] = qty;

    // Disable the quantity change buttons during the update process
    var $btn = jQuery('.item_' + item + ' .qty-minus-sub, .item_' + item + ' .qty-plus-sub');
    $btn.attr('disabled', true);
    $(".cart-page-listing").css("opacity", ".3");

    // AJAX request to update the cart
    jQuery.ajax({
        url: "/cart/update",
        type: "POST",
        data: formData,
        success: function(cart) {
            $btn.removeAttr('disabled'); // Enable the buttons again
            location.reload(); // Reload the page to update the cart view
            // Update cart count if necessary
            var count = jQuery('#cart-count', cart).text();
            jQuery('#cart-count').html(count);
            $("body").css({ opacity: 1.0 });
        },
        error: function(err) {
            // Revert changes if error occurs
            $btn.removeAttr('disabled');
            $(".cart-page-listing").css("opacity", ".3");
            jQuery('.item_' + item + ' .qty').val(qty - 1); // Revert quantity to the previous value
            jQuery(".err-msg").html("Error updating quantity.").css({ color: "red", fontWeight: 600 });
        }
    });
}

// Disable the "-" button if quantity is 1
function toggleMinusButton(item) {
    var $input = jQuery('.item_' + item + ' .qty');
    var value = parseInt($input.val());
    jQuery('.item_' + item + ' .qty-minus-sub').css('pointer-events', (value <= 1) ? 'none' : 'auto');
}

// Check the minus button status after page load
jQuery(document).ready(function() {
    jQuery('.qty').each(function() {
        var item = jQuery(this).attr('id').replace('slideCartQty-', '');
        toggleMinusButton(item); // Disable the minus button if quantity is 1
    });
});



$(document).ready(function () {
  $("ul.social li:first").click(function () {
    $(".share-social-media").toggle();
  });
});

//PDP page +/- 

$(document).on('click', '#add', function (e) {
  e.preventDefault();
  const $qtyBox = $('#pdpQty');
  let inputQty = parseInt($qtyBox.val(), 10);
  const maxQty = parseInt($qtyBox.attr('max'), 10);

  if (inputQty < maxQty) {
    inputQty++;
    $qtyBox.val(inputQty);
    updateHiddenQuantity(inputQty); // Update hidden input
  }
  toggleQuantityButtons(inputQty);
});

$(document).on('click', '#subtract', function (e) {
  e.preventDefault();
  const $qtyBox = $('#pdpQty');
  let inputQty = parseInt($qtyBox.val(), 10);
  const minQty = parseInt($qtyBox.attr('min'), 10);

  if (inputQty > minQty) {
    inputQty--;
    $qtyBox.val(inputQty);
    updateHiddenQuantity(inputQty); // Update hidden input
  }
  toggleQuantityButtons(inputQty);
});

function toggleQuantityButtons(inputQty) {
  const minQty = parseInt($('#pdpQty').attr('min'), 10);
  const maxQty = parseInt($('#pdpQty').attr('max'), 10);

  $('#subtract').prop('disabled', inputQty <= minQty);
  $('#add').prop('disabled', inputQty >= maxQty);
}

function updateHiddenQuantity(quantity) {
  // Dynamically update the hidden input field within the <product-form>
  $('product-form input[name="quantity"]').val(quantity);
}

$(document).ready(function () {
  const $qtyBox = $('#pdpQty');
  const inputQty = parseInt($qtyBox.val(), 10);

  toggleQuantityButtons(inputQty); // Ensure buttons are correctly enabled/disabled on load
});

$(document).on('submit', '.product-form', function (e) {
  const $qtyBox = $('#pdpQty');
  const inputQty = parseInt($qtyBox.val(), 10);

  // Ensure hidden input matches user-selected quantity
  updateHiddenQuantity(inputQty);
});

//Read more /less

 $(document).ready(function () {
        $(".toggle-btn").click(function () {
            const additionalInfo = $(this).siblings(".additional-info");
            if (additionalInfo.is(":visible")) {
                additionalInfo.slideUp(300);  
                $(this).text("Read More");
            } else {
                additionalInfo.slideDown(300);
                $(this).text("Read Less");
            }
        });
    });
